import React, {lazy, Suspense, useContext, useState} from 'react';
import {FaFilePdf, FaFilePowerpoint, FaFileWord} from 'react-icons/fa';
import {AppCtx} from '../../../AppCtx';
import {ThemeContext} from '../../../ThemeContext';
import {useSongContentService} from '../hooks/useSongContentService';
import FontSelectionModal from './FontSelectionModal';

const ExportPreviewDialog = lazy(() => import('./ExportPreviewDialog'));
const btnStyle = {cursor: 'pointer', borderRadius: '30%', padding: '5px', border: 0, background: 'transparent', font: 'inherit'};

const ExportButtonComponents = () => {
  const {selectedFile} = useContext(AppCtx);
  const {theme} = useContext(ThemeContext);
  const {songsJson} = useSongContentService();
  const [fontSource, setFontSource] = useState(null);
  const [request, setRequest] = useState(null);
  const open = format => {
    const snapshot = {format, fileName: selectedFile.name, isDarkMode: theme === 'dark',
      songs: JSON.parse(JSON.stringify(songsJson.songs))};
    if (format === 'docx') setFontSource(snapshot);
    else setRequest(snapshot);
  };
  const color = theme === 'dark' ? 'var(--icon-color-dark)' : 'var(--menu-icon-color)';
  return <>
    {[
      {format: 'docx', title: 'Eksportuj do Word', icon: FaFileWord},
      {format: 'pdf', title: 'Eksportuj do PDF', icon: FaFilePdf},
      {format: 'pptx', title: 'Eksportuj do PowerPoint', icon: FaFilePowerpoint},
    ].map(({format, title, icon: Icon}) => <button type="button" key={format} style={btnStyle}
      title={title} aria-label={title} disabled={!songsJson?.songs?.length || !selectedFile?.name}
      onClick={() => open(format)}><Icon style={{color}} /></button>)}
    <FontSelectionModal isOpen={!!fontSource} onClose={() => setFontSource(null)} confirmLabel="Podgląd Word"
      onConfirm={options => setRequest({...fontSource, options})} />
    {request && <Suspense fallback={<span role="status">Wczytywanie eksportu…</span>}>
      <ExportPreviewDialog request={request} onClose={() => setRequest(null)} />
    </Suspense>}
  </>;
};
export default ExportButtonComponents;
